import React from "react";
import { Menu } from "antd";
import "./styles.css";

const HexMenu = (props) => {
  const { menuList, onMenuClick, className } = props;

  return (
    <Menu
      className={`p-10 border-radius hex-menu ${className}`}
      items={menuList}
      onClick={onMenuClick}
    />
  );
};

export default HexMenu;
